/*
 * Runtime config for the K-Stack admin SPA.
 *
 * Unlike AquaStar Admin, this SPA is NOT tied to a single appId — it
 * operates the multi-tenant Nexus instance itself (nexus-dev.kstack.app
 * in dev). Every page it renders reads platform-tier data (apps, users,
 * credentials, metering, etc.) via /v1/admin/* endpoints exposed by
 * core/* modules in Nexus.
 *
 * Production builds: empty GATEWAY_BASE. The deployed SPA sits behind
 * its per-app Caddy on kiss-nas, which reverse-proxies /auth/* and /v1/*
 * to Nexus on the same origin. Same trick AquaStar Admin uses.
 *
 * Local dev (`npm run dev`): set VITE_GATEWAY_BASE in a
 * `.env.development.local` to e.g. `https://nexus-aquastar-dev.kstack.app`
 * to dev against a working remote Nexus while nexus-dev is being
 * stood up. CORS will need to allow http://localhost:5173 — set
 * NEXUS_CORS_ORIGINS in nexus-aquastar-dev's instance.env.
 */

export const GATEWAY_BASE: string = (import.meta.env.VITE_GATEWAY_BASE as string | undefined) ?? '';

/**
 * Optional stage label rendered in the AdminLayout topbar so an
 * operator can tell at a glance whether they're on dev / uat / prod.
 * Set VITE_STAGE=dev|uat|prod at build time.
 */
export const STAGE: string = (import.meta.env.VITE_STAGE as string | undefined) ?? 'dev';
